import type { Plugin, RouterContext } from '@atlassian/react-resource-router';
import { CAPABILITY_HEADER_NAME } from '@jira/platform__observability-capabilities/src/constants.tsx';

const CAPABILITY_HEADER_PLUGIN_ID = 'capability-header-plugin';

type SetCapability = (capability: string | null) => void;

const updateLegacyAjaxCapabilityHeader = (capability: string | null): void => {
	const ajax = globalThis.window?.AJS?.$;
	if (!ajax) {
		return;
	}

	if (capability === null) {
		if (ajax.ajaxSettings?.headers) {
			delete ajax.ajaxSettings.headers[CAPABILITY_HEADER_NAME];
		}
		return;
	}

	ajax.ajaxSetup({ headers: { [CAPABILITY_HEADER_NAME]: capability } });
};

const updateCapability = (context: RouterContext, setCapability: SetCapability): void => {
	const capability = context.route.meta?.capability ?? null;
	setCapability(capability);
	updateLegacyAjaxCapabilityHeader(capability);
};

export const createCapabilityHeaderPlugin = (setCapability: SetCapability): Plugin => ({
	id: CAPABILITY_HEADER_PLUGIN_ID,
	beforeRouteLoad: ({ nextContext }) => updateCapability(nextContext, setCapability),
	routeLoad: ({ context }) => updateCapability(context, setCapability),
});
